
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7125/api/',
    //Live

    // //DEV
    // apiUrl: 'https://at-api.off-ease.com/api/',
    // apiKey: 'Lieda1002',

     //DEV
    apiUrl: 'https://demo-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

